import React, { useState, useEffect } from "react";
import Header from "@/components/Header";
import { useAuth } from "@/hooks/use-auth";
import { useEditProfile } from "@/hooks/use-edit-profile";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export default function ProfileEditPaymentPage() {
    const { astrologer } = useAuth();
    const navigate = useNavigate();
    const { handleBankUpdate, loading } = useEditProfile();
    const [isLoading, setIsLoading] = useState(false);
    const [bankData, setBankData] = useState({
        DisplayName: "",
        bankName: "",
        bankAccountNumber: "",
        ifscCode: "",
        upi: "",
    });

    useEffect(() => {
        if (astrologer?.paymentDetails) {
            setBankData({
                DisplayName: astrologer.paymentDetails.DisplayName || "",
                bankName: astrologer.paymentDetails.bankName || "",
                bankAccountNumber: astrologer.paymentDetails.bankAccountNumber || "",
                ifscCode: astrologer.paymentDetails.ifscCode || "",
                upi: astrologer.paymentDetails.upi || "",
            });
        }
    }, [astrologer]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setBankData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSave = async () => {
        setIsLoading(true);
        try {
            await handleBankUpdate(bankData);
            // toast.success("Bank details updated successfully");
        } catch (error) {
            console.error("Error updating bank details:", error);
            toast.error("Failed to update bank details");
        } finally {
            setIsLoading(false);
            navigate("/profile");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full">
                {/* Header */}
                {/* <Header name="Bank Details" shouldGoBack={true} /> */}

                {/* Content Area */}
                <div>
                    <h1 className="text-2xl font-bold mb-6 text-center">Bank Details</h1>

                    <div className="flex flex-col gap-6">
                        {/* Name Field */}
                        <div className="flex flex-col">
                            <label className="mb-2 text-gray-700">
                                Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="DisplayName"
                                value={bankData.DisplayName}
                                onChange={handleInputChange}
                                placeholder="Enter your Name"
                                className="border border-gray-300 rounded-lg p-3 w-full"
                                required
                            />
                        </div>

                        {/* Bank Name Field */}
                        <div className="flex flex-col">
                            <label className="mb-2 text-gray-700">
                                Bank Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="bankName"
                                value={bankData.bankName}
                                onChange={handleInputChange}
                                placeholder="Enter your Bank Name"
                                className="border border-gray-300 rounded-lg p-3 w-full"
                                required
                            />
                        </div>

                        {/* Account Number and IFSC Code - Row */}
                        <div className="flex flex-col md:flex-row gap-4">
                            <div className="flex flex-col flex-1">
                                <label className="mb-2 text-gray-700">
                                    Account Number <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="bankAccountNumber"
                                    value={bankData.bankAccountNumber}
                                    onChange={handleInputChange}
                                    placeholder="Enter Account Number"
                                    className="border border-gray-300 rounded-lg p-3 w-full"
                                    required
                                />
                            </div>

                            <div className="flex flex-col flex-1">
                                <label className="mb-2 text-gray-700">
                                    IFSC Code <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="ifscCode"
                                    value={bankData.ifscCode}
                                    onChange={handleInputChange}
                                    placeholder="Enter IFSC Code"
                                    className="border border-gray-300 rounded-lg p-3 w-full"
                                    required
                                />
                            </div>
                        </div>

                        {/* UPI ID Field */}
                        <div className="flex flex-col">
                            <label className="mb-2 text-gray-700">
                                UPI id <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="upi"
                                value={bankData.upi}
                                onChange={handleInputChange}
                                placeholder="Add UPI id"
                                className="border border-gray-300 rounded-lg p-3 w-full"
                                required
                            />
                        </div>
                    </div>
                </div>
                <div className="flex justify-end mt-6">
                    <button
                        onClick={handleSave}
                        disabled={isLoading || loading}
                        className={`py-2 px-8 rounded-full text-white font-medium transition-colors ${isLoading || loading ? "bg-[#F05E23]/70" : "bg-[#F05E23]"
                            }`}
                    >
                        {isLoading || loading ? "Saving..." : "Save"}
                    </button>
                </div>
            </div>
        </div>
    );
}